import type { FC } from 'react';

import type { GenericSvgIconProps } from '../CustomIcon';

/** Custom icon for the AI Agent chat bubble with sparkle. */
export const AiAgentIcon: FC<GenericSvgIconProps> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 117 117"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M77.955 64.8792C77.955 63.0823 79.4216 61.611 81.2176 61.6021C83.0136 61.611 84.4803 63.0823 84.4803 64.8792V84.7055C84.4803 87.1961 83.1687 89.6212 80.9061 90.6043C78.742 91.5219 76.3483 91.1614 74.5776 89.5884L66.1506 82.0839C65.5604 81.5595 64.7734 81.2646 63.9864 81.2646H41.8859C34.6393 81.2646 28.7698 75.3986 28.7698 68.1563V41.9396C28.7698 34.6972 34.6393 28.8313 41.8859 28.8313H53.3624C55.1659 28.8313 56.6414 30.306 56.6414 32.1083C56.6414 33.9107 55.1659 35.3854 53.3624 35.3854H41.8859C38.279 35.3854 35.3279 38.3348 35.3279 41.9396V68.189C35.3279 71.7938 38.279 74.7432 41.8859 74.7432H66.4785C67.2654 74.7432 68.0524 75.0381 68.6426 75.5625L76.5778 82.6082C77.1353 83.067 77.955 82.7065 77.955 81.9856V64.8792Z"
        fill="currentColor"
      />
      <path
        d="M71.8683 30.1641C72.2161 29.3344 73.3779 29.282 73.8273 30.0078L73.9064 30.1641L76.9416 38.0264V38.0273C77.1721 38.6733 77.6427 39.1494 78.1994 39.4287L78.4426 39.5361L86.3117 42.5771V42.5781C87.1958 42.9494 87.1959 44.248 86.3117 44.6191L78.4543 47.6562C77.7169 47.9198 77.2008 48.4966 76.9465 49.1572L73.9064 57.0332C73.5587 57.8627 72.3968 57.9147 71.9474 57.1885L71.8683 57.0332L68.8283 49.1572C68.5629 48.4258 67.9884 47.9131 67.3312 47.6602L59.4631 44.6191C58.579 44.2479 58.5791 42.9494 59.4631 42.5781L59.4621 42.5771L67.3322 39.5352C68.0637 39.2696 68.5766 38.6957 68.8293 38.0381L68.8283 38.0371L71.8683 30.1641Z"
        fill="currentColor"
      />
    </svg>
  );
};

AiAgentIcon.displayName = 'AiAgentIcon';
